import { defineMessages } from "react-intl";

const messages = defineMessages({
  title: {
    id: "Appointment.AppointmentBookAdditionalViewsDialog.title",
    defaultMessage: "Book Additional Views",
  },
  description: {
    id: "Appointment.AppointmentBookAdditionalViewsDialog.description",
    defaultMessage: "Are you sure you want to reschedule this appointment?",
  },
  btnCancel: {
    id: "Appointment.AppointmentBookAdditionalViewsDialog.btnCancel",
    defaultMessage: "Cancel",
  },
  btnSubmit: {
    id: "Appointment.AppointmentBookAdditionalViewsDialog.btnSubmit",
    defaultMessage: "Save appointment",
  },
  overrideTimeLabel: {
    id: "Appointment.AppointmentBookAdditionalViewsDialog.overrideTimeLabel",
    defaultMessage: "Override Appointment Start Time",
  },
});

export default messages;
